'use client'
import styled from "styled-components";
import {hover, medium, white} from "@/styles/globalStyleVars";
import {Img} from "@/components/Img";
import Link from "next/link";
import parser from "html-react-parser";

const ProjectSingle = ({title, isSold, link, img, rent='', type, location, area, bedroom, washroom, areaImg, bedImg, washImg}) => {



    return (
        <StyledProjectSingle className='blog-single fade-up'  >
            <div className="blog-single__inner">
                <Link href={link || '/project/1'}></Link>
                <Img src={img} objectFit={'cover'} layout={'fill'}/>
                <div className="blog-single__inner__content">
                    <div className="blog-single__inner__content__top">
                        <div className={'blog-single__inner__content__top__full '}>
                            {
                                area &&
                                <div className={'d-flex align-items-center mb-2'}>
                                <span>
                                   <img src={areaImg ? areaImg : '/images/dynamic/project/h1.svg'}/>
                                </span>
                                    <span>
                                   <p>{'Area (sft)'}</p>
                                   <p>{parser(area)}</p>
                                </span>
                                </div>
                            }

                            {
                                bedroom &&
                                <div className={'d-flex align-items-center mb-2'}>
                                <span>
                                   <img src={bedImg ? bedImg : '/images/dynamic/project/h2.svg'}/>
                                </span>
                                    <span>
                                   <p>{'Bedrooms'}</p>
                                   <p>{bedroom ? bedroom : '03'}</p>
                                </span>
                                </div>
                            }

                            {
                                washroom &&
                                <div className={'d-flex align-items-center mb-2'}>
                                <span>
                                   <img src={washImg ? washImg : '/images/dynamic/project/h3.svg'}/>
                                </span>
                                    <span>
                                   <p>{'Bathrooms'}</p>
                                   <p>{washroom ? washroom : '03'}</p>
                                </span>
                                </div>
                            }


                        </div>

                    </div>
                    <div className="blog-single__inner__content__bottom split-up">
                        {
                            rent &&
                            <span className={`${rent === 'Buy' ? 'buy' : 'rent'}`}>{parser(rent)}</span>
                        }

                        {
                            title &&
                            <h4>{parser(title)}</h4>
                        }
                        <div className={'area'}>
                            <p>{parser(type)}</p>
                            <div className={'dot'}/>
                            <p>{parser(location)}</p>
                        </div>

                    </div>

                </div>
                {
                    isSold &&
                    <p className={'sold_out'}>Sold Out</p>
                }
            </div>
        </StyledProjectSingle>
    );
};

const StyledProjectSingle = styled.div`
  //width: 100%;
  margin-bottom: 30px;
  position: relative;  
    
  .sold_out{
      position: absolute;
      font-size: 12px;
      font-weight: 500;
      line-height: 13.44px;
      text-align: right;
      color: #000000;
      background-color: white;
      z-index: 1;
      right: 0;
      top: 20px;
      padding: 5px 10px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
  }  

  .blog-single__inner {
    padding-top: calc(470 / 370 * 100%);
    position: relative;
    overflow: hidden;
    .global-image{
      overflow: hidden;
      img{
        transform: scale(1.01);
        transition: 1.0s ease;
      }
    }
    &:hover {
      .global-image img{
        transform: scale(1.06) !important;
      }
    }


    a {
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 99;
    }


    &:after {
      content: '';
      //height: 0;
      width: 100%;
      //border-radius: var(--None, 0px);
      background: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 100%) !important;
      mix-blend-mode: multiply;
      height: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      transition: height .4s ease;
    }


    &__content {

      &:after {
        content: '';
        height: 0;
        width: 100%;
        //border-radius: var(--None, 0px);
        background-color: rgba(21, 22, 23, 0.5) !important;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        transition: height .4s ease;
      }

      &__top {
        img{
          margin-right: 10px;
        }
        &__full{

          position: absolute;
          left: 30px;
          top: 30px;
          z-index: 2;
          right: 30px;
          margin: 0;
          transform: translateY(-30px);
          opacity: 0;
          transition: all .6s ease;
     
          p{
            color: ${white} !important;
            font-size: 12px;    
            line-height: 18px;
            &:first-child{
              opacity: 0.7;
              font-weight: 500;              
            }
            &:last-child{
              font-weight: 700;
            }
          }
        }

      }

      &__bottom {
        position: absolute;
        margin: 0;
        left: 30px;
        right: 30px;
        bottom: 30px;
        //display: flex;
        justify-content: space-between;
        z-index: 2;

        span {
          width: 52px;
          height: 23px;
          border-radius: 10px;
          background-color: ${hover};
          font-size: 12px;
          font-family: ${medium};
          padding: 5px 10px;
          color: ${white};
            
            &.buy{
                background-color: #3081D0;
            }
        }

        .area {
          display: flex;
          align-items: center;

          p {
            font-size: 12px;
            line-height: 14px;
            color: ${white};
          }

          .dot {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: ${white};
            margin-left: 5px;
            margin-right: 5px;
          }
        }

        h4 {
          color: #FFF;
          transition: color .3s ease;
          margin-top: 10px;
          margin-bottom: 15px;
          
        }

      }
    }

    &:hover {

      .blog-single__inner__content__top {
        h5 {
          opacity: 0;
          transform: translateY(-20px);
        }

        div {
          transform: none;
          opacity: 1;
        }
      }

      .blog-single__inner__content__bottom {
        border-color: ${hover} !important;

        h1 {
          color: ${hover};
        }

        h6 {
          color: ${hover};

          span {
            color: ${hover};
          }
        }
      }
    }

    &:hover {
      .blog-single__inner__content:after {
        height: 100%;
      }
    }
  }

  @media (max-width: 767px) {
    .blog-single__inner__content__top {
      h5, h2 {
        left: 30px;
        right: 30px;
        top: 30px;
      }
    }

    .blog-single__inner__content__bottom h1, .blog-single__inner__content__bottom h6 {
      left: 30px;
      right: 30px;
      top: 30px;
    }

  }

`;
export default ProjectSingle;
